export const STORAGE_KEY = '_REDIRECT_URL';

const { sessionStorage } = window;

const escapeUrlFragment = (str: string): string => {
  // react-router interprets `:` character as a parameter specific token
  // more info [https://github.com/remix-run/react-router/issues/6376]
  return str.replaceAll(':', '\\:');
};

const parseUrlString = (urlString: string): URL | null => {
  try {
    return new URL(urlString);
  } catch (e) {
    console.error(e);
  }
  return null;
};

const injectToken = (urlObject: URL | null, token: string | null): URL | null => {
  if (!token) {
    return urlObject;
  }
  if (!urlObject) {
    return null;
  }
  urlObject = new URL(urlObject);
  urlObject.searchParams.set('token', token);
  return urlObject;
};

export const getRedirect = (token: string | null, options?: { shouldCleanUp: boolean }): string | null => {
  const urlString = sessionStorage.getItem(STORAGE_KEY);
  if (options?.shouldCleanUp) {
    sessionStorage.removeItem(STORAGE_KEY);
  }
  if (urlString) {
    const urlObject = injectToken(parseUrlString(urlString), token);
    return urlObject ? escapeUrlFragment(`${urlObject.pathname}${urlObject.search}`) : null;
  }
  return null;
};

export const setRedirect = (urlString: string) => {
  sessionStorage.setItem(STORAGE_KEY, urlString);
};
